import axios from 'axios'
import Store from '@/store'

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URI
})

axiosInstance.interceptors.request.use(config => {
    config.headers['Accept-Language'] = Store.state.lang

    return config
})

export { axiosInstance as axios }
